export const FINANCE_APPLICATION_START_TIME = 'FinanceApplicationStartTime';
